import { render, staticRenderFns } from "./Howtorent.vue?vue&type=template&id=6020a529&"
import script from "./Howtorent.vue?vue&type=script&lang=js&"
export * from "./Howtorent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports